import { AdStatus } from "../types";

export const statusLabels: Record<AdStatus, string> = {
  draft: "Utkast",
  customer_approved: "Godkänd av kund",
  pending_mediahouse_review: "Granskas",
  pending_cancellation_review: "Avbokning granskas",
  sent: "Skickad",
  rejected: "Refuserad",
  archived: "Arkiverad",
  cancelled: "Avbruten",
};
